module.exports = __webpack_public_path__ + "public/img/10.0f1fae8c.png";